export default __webpack_public_path__ + "static/media/640_store01-en-web.9275a6e8.png";